import { Routes, Route, Navigate } from "react-router-dom";
import {
  LoginPage,
  SignupPage,
  ForgotPasswordPage,
  ActivateAccountPage,
  // MagicLoginPage,
} from "../pages";

export const AuthRoute = () => {
  return (
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route path="signup" element={<SignupPage />} />
      <Route path="forgot-password" element={<ForgotPasswordPage />} />
      <Route path="activate-account" element={<ActivateAccountPage />} />
      {/* <Route path="magic-login" element={<MagicLoginPage />} /> */}
      <Route path="/*" element={<Navigate to={"login"} />} />
    </Routes>
  );
};
